import React from 'react';

// Ícones de contorno (traço 1.5, pontas arredondadas), herdam a cor do texto.
const Svg = ({ children }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const MoreIcon = () => (
  <Svg>
    <circle cx="12" cy="5" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="12" cy="19" r="1" />
  </Svg>
);
export const SearchIcon = () => (
  <Svg>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-4-4" />
  </Svg>
);
export const CloseIcon = () => (
  <Svg>
    <path d="M6 6l12 12M18 6L6 18" />
  </Svg>
);
export const PlusIcon = () => (
  <Svg>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);
export const ChevronLeftIcon = () => (
  <Svg>
    <path d="M15 6l-6 6 6 6" />
  </Svg>
);
export const ChevronRightIcon = () => (
  <Svg>
    <path d="M9 6l6 6-6 6" />
  </Svg>
);
export const DoubleChevronLeftIcon = () => (
  <Svg>
    <path d="M11 6l-6 6 6 6M19 6l-6 6 6 6" />
  </Svg>
);
export const DoubleChevronRightIcon = () => (
  <Svg>
    <path d="M13 6l6 6-6 6M5 6l6 6-6 6" />
  </Svg>
);
export const EyeIcon = () => (
  <Svg>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);
